var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('el-header',[_c('div',{staticClass:"title"},[_vm._v("管理系统")]),_c('div',[_vm._v(_vm._s(_vm.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }